import type { FC } from 'react'

import { RepeatIcon } from 'features/Schedule/pages/components/ManageAppointment/EhrAppointmentV2/Series/controls/SeriesIcons'
import { SERIES_TEXT_V2 } from 'features/Schedule/pages/components/ManageAppointment/EhrAppointmentV2/Series/seriesText'

import { toAppointmentSeriesLink } from '../api/series.transform'
import { SHOW_SERIES } from '../series.flags'

import styles from './seriesBadge.module.scss'

type Props = { link: unknown; className?: string }

// Marks the pill so the calendar click opens the Series popover only from it.
export const SERIES_PILL_ATTR = 'data-series-pill'

// The card's "k/N" pill; the calendar's eventClick reads clicks on it through SERIES_PILL_ATTR.
export const SeriesBadge: FC<Props> = ({ link: rawLink, className }) => {
  const link = SHOW_SERIES ? toAppointmentSeriesLink(rawLink) : null
  if (!link) return null

  const title =
    link.type === 'protocol'
      ? SERIES_TEXT_V2.pillTitleProtocol(link.step, link.total)
      : SERIES_TEXT_V2.pillTitle(link.step, link.total)
  return (
    <span
      title={title}
      aria-label={title}
      {...{ [SERIES_PILL_ATTR]: '' }}
      className={className ? `${styles.badge} ${className}` : styles.badge}>
      <RepeatIcon size={11} stroke={2.6} />
      {`${link.step}/${link.total}`}
    </span>
  )
}
